import en from './en.json';
import uk from './uk.json';
import pl from './pl.json';
import ru from './ru.json';
import es from './es.json';
import uz from './uz.json';
import hi from './hi.json';
import { createLocale } from '../../utils.js';

const locales = {
  en: createLocale(en, 'characteristics'),
  uk: createLocale(uk, 'characteristics'),
  pl: createLocale(pl, 'characteristics'),
  ru: createLocale(ru, 'characteristics'),
  es: createLocale(es, 'characteristics'),
  uz: createLocale(uz, 'characteristics'),
  hi: createLocale(hi, 'characteristics'),
};

export default locales;
